const trustItems = [
  {
    label: "Rooted",
    title: "Built on Indian wisdom that has lasted centuries",
    note: "Bhagavad Gita · Arthashastra · Ramayan · Mahabharata",
  },
  {
    label: "No agenda",
    title: "No guru, no therapist's mood, no sales pitch",
    note: "Just clear thinking, on your terms.",
  },
  {
    label: "Private",
    title: "Your Sessions stay yours",
    note: "We don't sell your data. We don't train on it.",
  },
  {
    label: "Practical",
    title: "Plain language. Real decisions.",
    note: "No mysticism. No jargon. No fluff.",
  },
];

export default function TrustScene() {
  return (
    <section className="home-band px-5 sm:px-8">
      <div className="max-w-4xl mx-auto w-full text-left">
        <p className="scroll-reveal section-eyebrow">Why trust this</p>

        <h2 className="scroll-reveal section-heading mt-3">
          Private. Practical.{" "}
          <span className="italic" style={{ color: "hsl(var(--marigold))" }}>
            On your side.
          </span>
        </h2>

        <div
          className="mt-10 sm:mt-14 border-t"
          style={{ borderColor: "hsl(var(--manuscript) / 0.08)" }}
        >
          {trustItems.map((item, i) => (
            <div
              key={item.title}
              className="scroll-reveal group relative grid grid-cols-[2.25rem_1fr] sm:grid-cols-[3rem_1fr_auto] items-baseline gap-3 sm:gap-6 py-5 sm:py-6 border-b"
              style={{ borderColor: "hsl(var(--manuscript) / 0.08)" }}
            >
              <span
                aria-hidden
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(90deg, transparent, hsl(var(--manuscript) / 0.025) 30%, hsl(var(--manuscript) / 0.025) 70%, transparent)",
                }}
              />

              <span
                className="font-display italic text-manuscript/35 tabular-nums relative"
                style={{ fontSize: "clamp(1.1rem, 1.6vw, 1.35rem)" }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>

              <div className="relative min-w-0">
                <h3
                  className="font-display text-manuscript leading-tight"
                  style={{ fontSize: "clamp(1.05rem, 1.9vw, 1.45rem)", letterSpacing: "-0.01em" }}
                >
                  {item.title}
                </h3>
                <p
                  className="mt-1.5 text-manuscript/55 leading-snug"
                  style={{ fontSize: "clamp(0.78rem, 1vw, 0.9rem)" }}
                >
                  {item.note}
                </p>
              </div>

              <span
                aria-hidden
                className="hidden sm:block relative section-eyebrow whitespace-nowrap"
              >
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
